/**
 * Chat do assistente — `POST /mensagens` e `GET /mensagens/{idMensagem}` (API User).
 *
 * Fonte: `gestao_mensagens.py` em `origin/dev` do backend, lido em 05/10/2026 depois
 * dos ajustes pedidos em `docs/ia-chat-ajustes-no-backend.md`.
 *
 * ⚠️ Dois pontos que diferem do resto da plataforma:
 *  - o erro DENTRO do polling usa `mensagem`; o envelope de erro HTTP continua `message`;
 *  - `especialistasAcionados` é o que o modelo chamou de fato, e pode vir vazio.
 */
import { z } from 'zod'

export const mensagemAceitaSchema = z.object({
  idConversa: z.string().min(1),
  idMensagem: z.string().min(1),
  /**
   * Hoje é sempre `processando`. `string`, e não literal, porque ninguém lê este
   * campo: recusar um 202 por causa dele deixaria órfão um job já aceito.
   */
  status: z.string(),
})

export type MensagemAceita = z.infer<typeof mensagemAceitaSchema>

export const statusDaMensagemSchema = z.discriminatedUnion('status', [
  z.object({ status: z.literal('processando') }),
  z.object({
    status: z.literal('concluida'),
    resposta: z.string().nullable(),
    especialistasAcionados: z.array(z.string()).default([]),
  }),
  z.object({
    status: z.literal('falha'),
    erro: z.object({ codigo: z.string(), mensagem: z.string() }),
  }),
])

export type StatusDaMensagem = z.infer<typeof statusDaMensagemSchema>

/**
 * Corpo do `POST /mensagens`. `idConversa` ausente abre uma conversa nova.
 *
 * `idCliente` vai em todo envio (BR-19) e é OBRIGATÓRIO: sem ele o backend responde
 * 400 `CLIENTE_OBRIGATORIO`; fora da lista do usuário, 403 `CLIENTE_FORA_DE_ESCOPO`.
 */
export interface CorpoDeMensagem {
  idCliente: string
  mensagem: string
  idConversa?: string
}
